<div style="background: #cccccc38;padding: 10px;margin: 0px -10px 25px -10px;">
    <span style="font-weight: 500;">Por favor,</span><span style="font-weight: 400;"> <br> presione su Yubikey para continuar.</span>
</div>
 <div style="height:50px; margin: 0 auto;width:80px;">
        <div class="c100" [class.p1]="porcentaje <= 50" [class.p51]="porcentaje > 50">
                <span *ngIf="flag === undefined">
                        <div style="font-family: 'yubifont';
                        font-size: 50px;
                        color: #4db53c;
                        top: -9px;
                        /* left: 2px; */
                        font-weight: 500;
                        position: relative;">y</div>
                </span>
                <span *ngIf="flag === true">
                        <i style="    padding-top: 10px;
                        font-size: 60px;
                        color: #4db53c;" class="material-icons">&#xE876;</i>
                </span>
                <span *ngIf="flag === false">
                        <i style="    padding-top: 10px;
                        font-size: 60px;
                        color: #b71c1c;" class="material-icons">&#xE14C;</i>
                </span>
                <div class="slice">
                    <div class="bar" [style.transform]="trans"></div>
                    <div class="fill"></div>
                </div>
            </div>                
</div>
<div *ngIf="error" style="overflow: hidden;display: inline-block;margin-top: 10px;color:#b71c1c;">
        <span style="font-weight: 500;">{{error}}</span><span><br>{{tip}}</span>    
</div>
